import { isNil } from "lodash-es";

export async function urlToText(url: string): Promise<string> {
  return await (await fetch(url)).text();
}

export function hasText(value: string): boolean {
  return !isNil(value) && value !== "";
}
